import * as S from "./styled";
import logo from "../../assets/Svg/icon.svg";
import React from "react";

interface PropsHeader {
    children?: React.ReactNode;
}

export default function Header({ children }: PropsHeader) {

    return (
        <S.Container>

            {!children && <S.SubContainer>
                <S.Logo src={logo} alt="logo" />
                <S.Title>
                    AB Gym Tips
                </S.Title>
            </S.SubContainer>
            }
            {children}
        </S.Container>
    );
}
